module.exports = __webpack_public_path__ + "static/media/h420_15.bcb71145199513e4076cd2105e52ef79.png";